import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  MapState,
} from '@gk/gk-modules';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import {
  ApiTimeString,
  DateHelperUtil,
  NgbDateRange,
} from '../../../../utils/date-helper/date-helper.util';

export interface MIRNewRequestDto extends ExtendedApplicantRequestDto {
  OpisObiektu: string;
  TerminRozpoczecia: string;
  Uzasadnienie: string;
  Lokalizacja?: string;
  TerminZakonczenia?: string;
  ZakresPrac?: string;
  Projekt?: string;
}

export class MIRNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public objectDescription: string,
    public justification: string,
    public foodCourtStartDate?: NgbDate,
    public determinationOfLocation?: string,
    public monumentInstallationDateRange?: NgbDateRange,
    public workScope?: string,
    public project?: string,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: MIRNewRequest,
    parcels: EgibObject[],
    buildings: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): MIRNewRequestDto {
    const isMonumentInstallationMode =
      data.requestMode === MIRRequestMode.MonumentInstallation;

    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        files,
        parcels,
        buildings,
      }),
      OpisObiektu: data.objectDescription,
      TerminRozpoczecia: data.requestMode
        ? DateHelperUtil.ngbDateToApiDateTime(
            isMonumentInstallationMode
              ? data.monumentInstallationDateRange?.from
              : data.foodCourtStartDate,
          )
        : undefined,
      Uzasadnienie: data.justification,
      Lokalizacja: data.determinationOfLocation,
      ...(isMonumentInstallationMode
        ? {
            TerminZakonczenia: DateHelperUtil.ngbDateToApiDateTime(
              data.monumentInstallationDateRange?.to,
              ApiTimeString.End,
            ),
            ZakresPrac: data.workScope,
            Projekt: data.project,
          }
        : {}),
    };
  }
}

export interface MIRNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: MIRNewRequest;
  mapState: MapState;
}

export enum MIRRequestMode {
  FoodCourt = 1,
  MonumentInstallation = 2,
}
